import type { TranslationKey } from '@change-corgi/core/i18n';

import type { ShareAction } from '#src/app/shared/hooks/share';

import type { ShareButtonConfig, ShareVariant } from './shareButtonConfig';
import { SHARE_BUTTON_CONFIG } from './shareButtonConfig';
import type { ShareChannel as PageShareChannel } from './types';

export type ShareActionItem = Readonly<{
	ShareAction: ShareAction['ShareAction'];
	channel: PageShareChannel;
	icon: React.ReactElement;
	label: TranslationKey;
	variant?: ShareVariant;
	successLabel?: TranslationKey;
	secondaryLabel?: TranslationKey;
	url: string;
}>;

type ShareButtonConfigOverride = Readonly<Partial<Pick<ShareButtonConfig, 'icon' | 'variant'>>>;

type Result = readonly ShareActionItem[];

function isPageShareAction(action: ShareAction): action is ShareAction {
	return action.channel in SHARE_BUTTON_CONFIG;
}

export function mapButtonConfigs(
	shareActions: readonly ShareAction[],
	overrides?: Readonly<Partial<Record<PageShareChannel, ShareButtonConfigOverride>>>,
): Result {
	return shareActions.filter(isPageShareAction).map(({ ShareAction, channel, url }) => ({
		ShareAction,
		channel,
		url,
		...SHARE_BUTTON_CONFIG[channel],
		...overrides?.[channel],
	}));
}
